import { useState, ChangeEvent, FormEvent } from "react";
import Image from "next/image";
import officeImg from "../../public/InformacionContacto.png";
import { BiPhone, BiMailSend } from "react-icons/bi";
import { FaMapMarkerAlt } from "react-icons/fa";
import Button from "./Button";

import { footer } from "@/config/footer";

interface FormData {
  userName: string;
  userEmail: string;
  userPhone: string;
  userSubject: string;
  userMessage: string;
}

const Contact = () => {
  const [formData, setFormData] = useState<FormData>({
    userName: "",
    userEmail: "",
    userPhone: "",
    userSubject: "",
    userMessage: "",
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    try {
      const response = await fetch("http://127.0.0.1:3001/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (response.status === 200) {
        alert("Mensaje enviado correctamente");
      } else {
        alert("Error al enviar el mensaje: " + result.message);
      }
    } catch (error) {
      console.error("Error al enviar el mensaje:", error);
      alert("Error al enviar el mensaje");
    }
  };

  return (
    <section className="page-contact bg-background py-16">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-primary">
          Contáctanos
        </h2>

        <div className="grid gap-8 md:grid-cols-2">
          {/* Sección de información de contacto */}
          <div className="md:col-span-1 flex flex-col items-center bg-background-contrast p-8 rounded-lg shadow-md space-y-4 bg-smoothed" >
            <h3 className="text-xl font-semibold text-primary">
              Información de Contacto
            </h3>
            <Image
              src={officeImg}
              alt="Office"
              className="rounded-lg shadow-md"
              width={500}
              height={300}
            />
            <div className="space-y-2">
              {footer.contacts.map((item, i) => {
                const Icon = item.icon;
                return (
                  <div key={i} className="flex items-center gap-1">
                    <Icon className="w-4 h-4 text-gray-light" />
                    <p className="text-small text-gray-light">{item.label}</p>
                  </div>
                );
              })}
            </div>
            
          </div>

          {/* Sección del mapa */}
          <div className="md:col-span-1 bg-background-contrast p-8 rounded-lg shadow-md bg-smoothed">
            <h3 className="text-xl font-semibold text-center mb-4 text-primary">
              Nuestra Ubicación
            </h3>
            <iframe
src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15605.99699110505!2d-77.011428!3d-12.077936!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c881cec8df5f%3A0x5202682571db45d0!2sC.%20Fermin%20Tanguis%20160%2C%20La%20Victoria%2015034%2C%20Per%C3%BA!5e0!3m2!1ses-419!2sus!4v1720888086930!5m2!1ses-419!2sus"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen={true}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-lg shadow-md"
            ></iframe>
            <a
              href="https://maps.app.goo.gl/kuxfdbFGHt5CVWkv5"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-dark block text-center mt-2 underline"
            >
              Ver en Google Maps
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
